export var NotificationType;
(function (NotificationType) {
    NotificationType["ALL"] = "ALL";
    NotificationType["POST"] = "POST";
    NotificationType["COMMENT"] = "COMMENT";
    NotificationType["REACTION"] = "REACTION";
    NotificationType["MEMBERSHIP"] = "MEMBERSHIP";
    NotificationType["MEMBERS_JOIN"] = "MEMBERS_JOIN";
    NotificationType["GROUP_UPDATES"] = "GROUP_UPDATES";
    NotificationType["WEEKLY_DIGEST"] = "WEEKLY_DIGEST";
})(NotificationType || (NotificationType = {}));
export var NotificationChannel;
(function (NotificationChannel) {
    NotificationChannel["WEB"] = "WEB";
    NotificationChannel["MOBILE"] = "MOBILE";
    NotificationChannel["EMAIL"] = "EMAIL";
})(NotificationChannel || (NotificationChannel = {}));
//# sourceMappingURL=types.impl.js.map